import { Widget } from '../../../Widget';
import { ITableWidgetCell, TableCellType } from './ITableCell';
import { ITableInputWidget } from './ITableInputWidget';
import { isCustomRow } from './ITableRow';
import { engineWidgetCellId } from './expression/materializeTableInputWidget';
import { ITableInputWidgetColumnsContext } from './render/useTableInputWidgetColumns';

/**
 * Ottiene il widget alla cella specificata, tenendo in considerazione che
 * possono esserci celle vuote e righe personalizzate con Widget dedicati.
 */
export function getTableWidgetAtCell(
  table: ITableInputWidget,
  context: ITableInputWidgetColumnsContext,
  rowIndex: number,
  columnIndex: number,
): Widget | undefined {
  const { columns, rows } = table;
  const { materializedWidgets } = context;
  const row = context.rows[rowIndex];
  const column = columns[columnIndex];

  if (isCustomRow(row)) {
    // Ci assicuriamo che sia di tipo Widget e che corrisponda alla colonna
    // attuale.
    const cell = row.cells.find(
      (c): c is ITableWidgetCell =>
        c.type === TableCellType.Widget && c.columnId === column.id,
    );

    return cell?.widget;
  }

  return materializedWidgets.find(
    w =>
      w.fromVirtualId === column.id &&
      w.id === engineWidgetCellId(table, row.id, column.id),
  );
}
